var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("img", { attrs: { src: _vm.resultImg, alt: "" } }),
      _vm._v(" "),
      _c("h2", [_vm._v("上传成功")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("您参与比赛的上传材料阶段已经圆满完成，祝您取得理想成绩。")
      ]),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticClass: "btn-warpper",
          attrs: { type: "default" },
          on: { click: _vm.clickExit }
        },
        [_vm._v("知道了")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0996f752", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0996f752","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Result.vue
// module id = null
// module chunks = 